<template>
    <div class="active-search-filters text-xs">
        <slot></slot>
        <search-filters-display
            :term="term"
            :filters="allFilters"
            :read-only="readOnly"
            :show-clear-all="showClearAll"
            :unsupported-keys="unsupportedKeys"
            @clear="clear"
            @clear-term="$emit('clear-term')"
            @clear-all="clearAll"
        ></search-filters-display>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    // Internal Dependencies
    import ActiveFiltersMixin from '@Vault/Filters/mixins/ActiveFiltersMixin.js';
    import SearchFiltersDisplay from '@Vault/Filters/components/SearchFiltersDisplay.vue';

    export default {
        name: 'ActiveSearchFilters',

        mixins: [ActiveFiltersMixin],

        props: {
            term: {
                type: String,
                default: '',
            },

            readOnly: {
                type: Boolean,
                default: false,
            },

            showClearAll: {
                type: Boolean,
                default: false,
            },

            unsupportedKeys: {
                type: Array,
                default: () => [],
            },
        },

        methods: {
            ...mapActions('search_filters', [
                'clearFilter',
                'clearFilterNamespace',
            ]),

            clear(filter, router_action = 'replace') {
                if ( this.hasFilter(filter) ) {
                    this.$emit('clear', filter);
                }

                let {key, sub_key} = filter;
                key = this.dependentFilters[key] || key;

                if ( ['push', 'replace'].includes(router_action) ) {
                    this.$router[router_action]({
                        ...this.$route,
                        query: this.getQueryParamsWithout(key, sub_key),
                    });
                }

                this.clearFilter({
                    namespace: this.namespace,
                    which: key,
                    sub_key,
                });
            },

            clearAll() {
                this.clearFilterNamespace(this.namespace);
                this.$emit('clear-all');
            },

            getQueryParamsWithout(key, sub_key = null, query = null) {
                query ??= {...this.$route.query};

                if ( Array.isArray(key) ) {
                    return key.reduce((new_query, query_key) => {
                        return this.getQueryParamsWithout(query_key, sub_key, query);
                    }, query);
                }

                if ( sub_key && query[key].includes(':') ) {
                    // filter object - remove sub_key/value
                    query[key] = query[key].split(';')
                        .filter(sub_key_val => sub_key_val.split(':')[0] !== sub_key)
                        .join(';');

                    // if resulting filter object has empty value, remove it
                    if ( query[key] === '' ) {
                        delete query[key];
                    }

                } else {
                    // legacy filter - remove key
                    delete query[key];
                }

                return query;
            },
        },

        components: {
            SearchFiltersDisplay,
        },
    }
</script>
